<button #openDrawerButton command="show-modal" commandfor="drawer"
    class="sr-only rounded-md bg-gray-950/5 px-2.5 py-1.5 text-sm font-semibold text-primary hover:bg-gray-950/10">Open
    drawer</button>
<el-dialog>
    <dialog #drawerDialog id="drawer" aria-labelledby="drawer-title"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
        <el-dialog-backdrop (click)="closeDrawer()"
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>
        <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
            (click)="$event.stopPropagation()">

            <el-dialog-panel
                class="ml-auto block size-full max-w-md transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full flex-col overflow-y-auto bg-white shadow-xl rounded-xl">


                    <!-- header -->
                    <!-- <div class="bg-indigo-700 px-2 py-4"> -->
                    <div class="px-2 py-4 drawer-header-primary">
                        <div class="flex space-x-3 h-full items-center">
                            <div class="min-w-0 flex-1 px-2">
                                <p class="text-md font-semibold text-primary">
                                    Wallet Top-up
                                </p>
                                <p class="text-sm text-secondary">
                                    Use these funds to hire & pay creators.
                                </p>
                            </div>

                            <div class="h-full flex flex-col justify-between items-end">

                                <button type="button" (click)="closeDrawer()"
                                    class="btn-fab-secondary text-secondary">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5">
                                        <path d="M18 6 6 18" />
                                        <path d="m6 6 12 12" />
                                    </svg>
                                </button>

                            </div>
                        </div>
                    </div>
                    <!-- header - END -->

                    <!-- main content -->
                    <div
                        class="relative h-full flex-1 flex-col items-center justify-center w-full overflow-hidden drawer-body-primary">

                        <!-- Stats Overview -->
                        <div class="relative isolate overflow-hidden">
                            <!-- Secondary navigation -->


                            <!-- Stats -->
                            <div
                                class="border-b border-b-zinc-200 dark:border-b-zinc-800 lg:border-t lg:border-t-zinc-200 dark:border-t-zinc-800">
                                <dl class="mx-auto grid max-w-7xl grid-cols-2 lg:px-2 xl:px-0">
                                    <div
                                        class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 border-t border-zinc-200 dark:border-zinc-800 px-4 py-4 sm:px-6 lg:border-t-0 xl:px-8">
                                        <dt class="text-sm font-medium leading-6 text-secondary">Current Balance</dt>
                                        <dd
                                            class="w-full flex-none text-3xl font-medium leading-10 tracking-tight text-primary">
                                            {{ walletService.currentBalance() !== undefined ?
                                            (walletService.currentBalance() |
                                            currency:
                                            walletService.currencyCode()?.toUpperCase()) : 'Loading...' }}</dd>
                                    </div>
                                    <div
                                        class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 border-t border-zinc-200 dark:border-zinc-800 px-4 py-4 sm:border-l sm:px-6 lg:border-t-0 xl:px-8">
                                        <dt class="text-sm font-medium leading-6 text-secondary">Available Balance
                                        </dt>
                                        <dd
                                            class="w-full flex-none text-3xl font-medium leading-10 tracking-tight text-primary">
                                            {{
                                            walletService.availableBalance() !== undefined ?
                                            (walletService.availableBalance() |
                                            currency:
                                            walletService.currencyCode()?.toUpperCase()) : 'Loading...' }}</dd>
                                    </div>
                                </dl>
                            </div>

                            <div class="absolute left-0 top-full -z-10 mt-96 origin-top-left translate-y-40 -rotate-90 transform-gpu opacity-20 blur-3xl sm:left-1/2 sm:-ml-96 sm:-mt-10 sm:translate-y-0 sm:rotate-0 sm:transform-gpu sm:opacity-50"
                                aria-hidden="true">
                                <div class="aspect-[1154/678] w-[72.125rem] bg-gradient-to-br from-[#FF80B5] to-[#9089FC]"
                                    style="clip-path: polygon(100% 38.5%, 82.6% 100%, 60.2% 37.7%, 52.4% 32.1%, 47.5% 41.8%, 45.2% 65.6%, 27.5% 23.4%, 0.1% 35.3%, 17.9% 0%, 27.7% 23.4%, 76.2% 2.5%, 74.2% 56%, 100% 38.5%)">
                                </div>
                            </div>
                        </div>
                        <!-- Stats Overview END -->

                        <!-- Redeem voucher -->
                        <div class="px-4 py-5 sm:p-4">
                            <h3 class="block text-sm/6 font-medium text-primary">Redeem voucher</h3>
                            <form class="mt-2 max-w-xl text-sm text-gray-500" (submit)="redeemVoucher($event)">
                                <div class="mt-2 flex w-full flex-row items-center gap-x-2 sm:flex sm:items-center">
                                    <div class="flex-1">
                                        <div
                                            class="relative flex items-center rounded-md bg-white/50 outline-1 -outline-offset-1 outline-zinc-300 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-primary dark:bg-white/5 dark:outline-white/10">
                                            <div class="shrink-0 text-secondary w-[30px] flex items-center justify-center"
                                                aria-hidden="true">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                    class="size-4">
                                                    <path
                                                        d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
                                                    <path d="M13 5v2" />
                                                    <path d="M13 17v2" />
                                                    <path d="M13 11v2" />
                                                </svg>
                                            </div>
                                            <input id="top-up-voucher-name" type="text" autocomplete="off"
                                                placeholder="Enter voucher name"
                                                class="block min-w-0 grow py-1.5 pr-3 pl-1 text-sm text-primary placeholder:text-gray-500 outline-zinc-300 focus:outline-none sm:text-sm/6 dark:outline-white/10"
                                                [value]="voucherName()" (input)="onVoucherNameInput($event)" />
                                        </div>
                                    </div>
                                    <button type="submit" class="primary-button"
                                        [disabled]="redeemingVoucher() || !voucherName().trim()">
                                        {{ redeemingVoucher() ? 'Redeeming…' : 'Redeem' }}
                                    </button>
                                </div>
                            </form>
                        </div>
                        <!-- Redeem voucher END -->


                        <!-- Request Amount -->
                        <div class="px-4 py-5 sm:p-4" *appHasRole="[4]">
                            <h3 class="block text-sm/6 font-medium text-primary">Request Top-up</h3>
                            <div class="mt-2 max-w-xl text-sm text-gray-500">
                                <div class="w-full mt-2 sm:flex sm:items-center flex flex-row gap-x-2">

                                    <div class="flex-1">
                                        <div
                                            class="relative flex items-center rounded-md bg-white/50 dark:bg-white/5 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-primary">
                                            <div
                                                class="shrink-0 text-base text-secondary select-none sm:text-sm/6 w-[30px] flex items-center justify-center">
                                                {{ walletService.currencyCode()?.toUpperCase() == 'USD' ? '$' :
                                                walletService.currencyCode()?.toUpperCase() == 'EUR' ? '€' : '£' }}
                                            </div>
                                            <input [(ngModel)]="customTopUpRequest" id="price" type="number"
                                                placeholder="0.00"
                                                class="block min-w-0 grow py-1.5 pr-3 pl-1 text-sm text-primary outline-zinc-300 dark:outline-white/10 placeholder:text-gray-500 focus:outline-none sm:text-sm/6" />
                                            <div class="grid shrink-0 grid-cols-1 focus-within:relative">
                                                <span class="text-gray-500 sm:text-sm px-2" id="price-currency">{{
                                                    walletService.currencyCode() ?
                                                    walletService.currencyCode()?.toUpperCase() :
                                                    currentUserService.focussedBrand.currencyCode.toUpperCase()
                                                    }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" (click)="topupRequest()"
                                        class="secondary-button text-secondary">
                                        Request
                                    </button>
                                </div>
                                @if (customTopUpRequest && customTopUpRequest < 100) { <p
                                    class="mt-2 text-sm text-red-600" id="email-error">
                                    {{ 100 | currency : walletService.currencyCode()?.toUpperCase() }} minimum top-up
                                    value.
                                    </p>
                                    }
                            </div>
                        </div>
                        <!-- Request Amount END -->

                        <!-- Top Up Amount -->
                        <div class="px-4 py-5 sm:p-4">
                            <h3 class="block text-sm/6 font-medium text-primary">Top-up Wallet</h3>
                            <div class="mt-2 max-w-xl text-sm text-gray-500">
                                <div class="w-full mt-2 sm:flex sm:items-center flex flex-row gap-x-2">

                                    <div class="flex-1">
                                        <div
                                            class="relative flex items-center rounded-md bg-white/50 dark:bg-white/5 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-primary">
                                            <div
                                                class="shrink-0 text-base text-secondary select-none sm:text-sm/6 w-[30px] flex items-center justify-center">
                                                {{ walletService.currencyCode()?.toUpperCase() == 'USD' ? '$' :
                                                walletService.currencyCode()?.toUpperCase() == 'EUR' ? '€' : '£' }}
                                            </div>
                                            <input [(ngModel)]="customTopUp" id="price" data-guide-id="wallet.amount"
                                                type="number" placeholder="0.00"
                                                class="block min-w-0 grow py-1.5 pr-3 pl-1 text-sm text-primary outline-zinc-300 dark:outline-white/10 placeholder:text-gray-500 focus:outline-none sm:text-sm/6" />
                                            <div class="grid shrink-0 grid-cols-1 focus-within:relative">
                                                <span class="text-gray-500 sm:text-sm px-2" id="price-currency">{{
                                                    walletService.currencyCode() ?
                                                    walletService.currencyCode()?.toUpperCase() :
                                                    currentUserService.focussedBrand.currencyCode.toUpperCase()
                                                    }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" (click)="customDeposit()" data-guide-id="wallet.deposit"
                                        class="primary-button">
                                        Deposit
                                    </button>
                                </div>
                                @if (customTopUpRequest && customTopUpRequest < 100) { <p
                                    class="mt-2 text-sm text-red-600" id="email-error">
                                    {{ 100 | currency : walletService.currencyCode()?.toUpperCase() }} minimum top-up
                                    value.
                                    </p>
                                    }
                            </div>
                        </div>
                        <!-- Top Up Amount END -->

                        <!-- Top Up Options -->
                        <div class="mt-6 px-4">
                            <h3 class="block text-sm/6 font-medium text-primary">Recommended Top-up Values</h3>
                            <ul role="list" class="mt-4 grid grid-cols-1 gap-4">
                                @for (amount of walletService.topUpAmountOptions; track $index) {
                                <li>
                                    <button type="button" (click)="topUpWithAmount(amount)"
                                        [attr.data-guide-id]="$index === 1 ? 'wallet.recommendedTopUp' : null"
                                        class="group flex w-full items-center justify-between space-x-3 rounded-full border border-gray-300 dark:border-white/10 p-2 text-left shadow-sm hover:bg-gray-50 dark:hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2">
                                        <span class="flex min-w-0 flex-1 items-center space-x-3">
                                            <span class="block flex-shrink-0">
                                                @if (walletService.currencyCode() !== 'usd') {
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                    fill="#4338ca" class="w-10 h-10">
                                                    <path fill-rule="evenodd"
                                                        d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM9.763 9.51a2.25 2.25 0 013.828-1.351.75.75 0 001.06-1.06 3.75 3.75 0 00-6.38 2.252c-.033.307 0 .595.032.822l.154 1.077H8.25a.75.75 0 000 1.5h.421l.138.964a3.75 3.75 0 01-.358 2.208l-.122.242a.75.75 0 00.908 1.047l1.539-.512a1.5 1.5 0 01.948 0l.655.218a3 3 0 002.29-.163l.666-.333a.75.75 0 10-.67-1.342l-.667.333a1.5 1.5 0 01-1.145.082l-.654-.218a3 3 0 00-1.898 0l-.06.02a5.25 5.25 0 00.053-1.794l-.108-.752H12a.75.75 0 000-1.5H9.972l-.184-1.29a1.863 1.863 0 01-.025-.45z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                                } @else {
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                    fill="#4338ca" class="w-8 h-8">
                                                    <path
                                                        d="M10.464 8.746c.227-.18.497-.311.786-.394v2.795a2.252 2.252 0 01-.786-.393c-.394-.313-.546-.681-.546-1.004 0-.323.152-.691.546-1.004zM12.75 15.662v-2.824c.347.085.664.228.921.421.427.32.579.686.579.991 0 .305-.152.671-.579.991a2.534 2.534 0 01-.921.42z" />
                                                    <path fill-rule="evenodd"
                                                        d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v.816a3.836 3.836 0 00-1.72.756c-.712.566-1.112 1.35-1.112 2.178 0 .829.4 1.612 1.113 2.178.502.4 1.102.647 1.719.756v2.978a2.536 2.536 0 01-.921-.421l-.879-.66a.75.75 0 00-.9 1.2l.879.66c.533.4 1.169.645 1.821.75V18a.75.75 0 001.5 0v-.81a4.124 4.124 0 001.821-.749c.745-.559 1.179-1.344 1.179-2.191 0-.847-.434-1.632-1.179-2.191a4.122 4.122 0 00-1.821-.75V8.354c.29.082.559.213.786.393l.415.33a.75.75 0 00.933-1.175l-.415-.33a3.836 3.836 0 00-1.719-.755V6z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                                }

                                            </span>
                                            <span class="block min-w-0 flex-1">
                                                <span class="block truncate text-lg font-medium text-primary">{{
                                                    amount
                                                    |
                                                    currency: walletService.currencyCode()?.toUpperCase() }}</span>
                                            </span>
                                        </span>
                                        <span class="inline-flex h-10 w-10 flex-shrink-0 items-center justify-center">
                                            <svg class="h-5 w-5 text-gray-400 group-hover:text-gray-500"
                                                viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                <path
                                                    d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
                                            </svg>
                                        </span>

                                    </button>
                                </li>
                                }
                            </ul>
                        </div>
                        <!-- Top Up Options END -->



                    </div>
                    <!-- main content - END -->

                    <!-- footer -->
                    <!-- <div class="px-4 py-4 drawer-header-primary flex flex-row items-center justify-end gap-x-4">

                    </div> -->
                    <!-- footer - END -->
                </div>
            </el-dialog-panel>

        </div>
    </dialog>
</el-dialog>